import { useState } from "react"
import { PropTypes } from "prop-types"
import classNames from "classnames"

import ButtonModal from "./ButtonModal"
import Modal from "../Modal"

export function ButtonWithModal(props) {
  const [isOpen, setIsOpen] = useState(false)
  const { button, modal, children, onClearError } = props

  const handleCloseModal = () => {
    setIsOpen(false)
    if (onClearError) {
      onClearError()
    }
  }

  const handleOpenModal = () => {
    setIsOpen(true)
    if (onClearError) {
      onClearError()
    }
  }

  const callChildren = typeof children === "function"

  return (
    <>
      <ButtonModal {...button} onClick={handleOpenModal} />
      <Modal
        cssClassName={classNames("oj-button-with-modal", modal.className)}
        contentLabel={modal.contentLabel}
        isPrintable={modal.isPrintable}
        onClose={handleCloseModal}
        isOpen={isOpen}
      >
        {!modal.hideHeader && (
          <Modal.Header onClose={handleCloseModal}>{modal.contentLabel}</Modal.Header>
        )}
        <Modal.Content>{callChildren ? children(handleCloseModal) : children}</Modal.Content>
      </Modal>
    </>
  )
}

ButtonWithModal.propTypes = {
  onClearError: PropTypes.func,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  button: PropTypes.shape({
    className: PropTypes.string,
    label: PropTypes.node,
    ariaLabel: PropTypes.string,
    action: PropTypes.func
  }),
  modal: PropTypes.shape({
    className: PropTypes.string,
    contentLabel: PropTypes.string,
    isPrintable: PropTypes.bool,
    hideHeader: PropTypes.bool
  }).isRequired
}

export default ButtonWithModal
